import React, { Component } from 'react'
import styled from 'styled-components'
import moment from 'moment'
import { media } from 'styled-bootstrap-grid'

import { Text } from 'ui/styles/utils'
import FadeEntry from 'ui/components/generic/FadeEntry'
import Button from 'ui/components/generic/Button'

const Wrapper = styled.div`
  position: relative;
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  color: #fff;
`

const Header = Text.extend`
  position: relative;
  margin-bottom: 50px;
  text-align: center;

  &:after {
    display: block;
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-top: 50px;
    margin-left: -25px;
    height: 2px;
    width: 50px;
    background-color: #fff;
  }

  ${media.xs`
    margin-bottom: 20px;

    &:after {
      margin-top: 20px;
    }
  `}
`.withComponent('h1')

const SubTitle = Text.extend`
  margin: 50px 10vw;
  text-align: center;

  ${media.xs`
    margin: 20px 10vw;
  `}
`.withComponent('h2')

class index extends Component {
  render() {
    const {
      post: { title, concertDate, ticketLink, setup }
    } = this.props

    return (
      <Wrapper>
        <SubTitle size="lg">Kajsa Vala {setup && `- ${setup.title}`}</SubTitle>
        <Header size="xl">{title}</Header>
        <FadeEntry delay={1000} scroll={false}>
          <SubTitle size="md">
            {moment(concertDate).format('dddd D MMMM YYYY')}
          </SubTitle>
        </FadeEntry>
        {ticketLink && (
          <FadeEntry delay={1200} scroll={false}>
            <Button component="a" href={ticketLink} target="_blank">
              Buy ticket
            </Button>
          </FadeEntry>
        )}
      </Wrapper>
    )
  }
}

export default index



// WEBPACK FOOTER //
// ./src/ui/components/views/Concert.js